module.exports = __webpack_public_path__ + "UCSF_Logo-41d6bbe19a7cbc0fd7992c09084f05a5.png";